/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `High` - High
 * * `Medium` - Medium
 * * `Low` - Low
 * @export
 */
export const MaterialityEnum = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
} as const;
export type MaterialityEnum = (typeof MaterialityEnum)[keyof typeof MaterialityEnum];

export function instanceOfMaterialityEnum(value: any): boolean {
  for (const key in MaterialityEnum) {
    if (Object.prototype.hasOwnProperty.call(MaterialityEnum, key)) {
      if ((MaterialityEnum as Record<string, MaterialityEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function MaterialityEnumFromJSON(json: any): MaterialityEnum {
  return MaterialityEnumFromJSONTyped(json, false);
}

export function MaterialityEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialityEnum {
  return json as MaterialityEnum;
}

export function MaterialityEnumToJSON(value?: MaterialityEnum | null): any {
  return value as any;
}
